export class AOState {
  number: number;
  value: number;

  constructor() {
    this.number = 0;
    this.value = 0;
  }
}

export interface AnalogOutStatus {
  AO: AOState[];
}

